<head>
  <meta name="viewport" content="width=device-width, initial-scale=1">
</head>

<!-- Simple Popup Notification -->
@if (showNotification) {
  <div
     [ngClass]="{
       'bg-bosch-green-50 border-bosch-green-200 text-bosch-green-800': notificationType === 'success',
       'bg-bosch-red-50 border-bosch-red-200 text-bosch-red-800': notificationType === 'error',
       'bg-bosch-blue-50 border-bosch-blue-200 text-bosch-blue-800': notificationType === 'info'
     }"
    class="fixed top-2.5 left-1/2 transform -translate-x-1/2 z-50 border px-4 py-2 rounded-bosch-md shadow-bosch-sm flex items-center gap-3">
    <span>{{ notificationMessage }}</span>
    <button (click)="hideNotification()"
          [ngClass]="{
            'text-bosch-green-600 hover:text-bosch-green-800': notificationType === 'success',
            'text-bosch-red-600 hover:text-bosch-red-800': notificationType === 'error',
            'text-bosch-blue-600 hover:text-bosch-blue-800': notificationType === 'info'
          }"
    class="text-xl font-bold leading-none">×</button>
  </div>
}

<div class="max-w-[95%] mx-auto px-2 sm:px-3 lg:px-4">

  <div class="text-bosch-h1 font-bosch-strong text-bosch-gray-900 mt-bosch-xl mb-bosch-lg">Manage my links - {{filterStatus}}</div>

  <div class="mb-bosch-lg">
    <button class="inline-flex items-center gap-bosch-sm bg-bosch-blue-500 hover:bg-bosch-blue-600 text-white font-bosch-medium py-bosch-sm px-bosch-lg rounded-bosch-md border-2 border-bosch-blue-700 hover:border-bosch-blue-800 transition-all duration-200 text-center justify-center" routerLink="/">
      <img src="../ui/assets/img/circle-arrow-left-svgrepo-com.svg" alt="Add" class="w-5 h-5 brightness-0 invert" />
      Create New URL
    </button>
  </div>

  <div class="bg-white rounded-bosch-lg shadow-bosch-md border border-bosch-gray-200 p-bosch-xl mb-bosch-lg">
    <div class="flex flex-col sm:flex-row gap-bosch-md mb-bosch-md">
      <button
          [ngClass]="{
            'bg-bosch-blue-500 text-white shadow-bosch-sm': filterStatus === 'All',
            'bg-white text-bosch-blue-500 border-bosch-blue-500 hover:bg-bosch-blue-50': filterStatus !== 'All'
          }" 
        class="px-bosch-md py-bosch-sm border rounded-bosch-md font-bosch-medium transition-all duration-200 text-center"
        (click)="refreshRecords('All')">All
      </button>
      <button
          [ngClass]="{
            'bg-bosch-green-500 text-white shadow-bosch-sm': filterStatus === 'Published',
            'bg-white text-bosch-green-500 border-bosch-green-500 hover:bg-bosch-green-50': filterStatus !== 'Published'
          }" 
        class="px-bosch-md py-bosch-sm border rounded-bosch-md font-bosch-medium transition-all duration-200 text-center"
        (click)="refreshRecords('Published')">Published
      </button>
      <button
          [ngClass]="{
            'bg-bosch-gray-500 text-white shadow-bosch-sm': filterStatus === 'Archived',
            'bg-white text-bosch-gray-600 border-bosch-gray-500 hover:bg-bosch-gray-50': filterStatus !== 'Archived'
          }" 
        class="px-bosch-md py-bosch-sm border rounded-bosch-md font-bosch-medium transition-all duration-200 text-center"
        (click)="refreshRecords('Archived')">Archived
      </button>
      <button
          [ngClass]="{
            'bg-bosch-gray-500 text-white shadow-bosch-sm': filterStatus === 'Deleted',
            'bg-white text-bosch-gray-600 border-bosch-gray-500 hover:bg-bosch-gray-50': filterStatus !== 'Deleted'
          }" 
        class="px-bosch-md py-bosch-sm border rounded-bosch-md font-bosch-medium transition-all duration-200 text-center inline-flex items-center gap-2"
        (click)="refreshRecords('Deleted')">
        <img src="../ui/assets/img/delete.svg" alt="Recycle Bin" class="w-4 h-4">
        Recycle Bin
      </button>
    </div>
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-bosch-md">
      <div class="text-bosch-gray-600 font-bosch">
        You have {{this.userLinkCount}} links.
        @if (filterStatus === 'Deleted') {
          <div class="text-sm text-pink-600 mt-1">
            Deleted items will be removed from recycle bin after {{recycleBinDays}} days permanently.
          </div>
        }
      </div>
      @if (selectedItemsCount > 0) {
        <div class="text-bosch-blue-500 font-bosch-medium animate-bosch-fade-in">
          Selected Items: {{ selectedItemsCount }}
        </div>
      }
    </div>
  </div>
  <div class="bg-white rounded-bosch-lg shadow-bosch-md border border-bosch-gray-200 overflow-hidden">
    <!-- Responsive table container - no horizontal scroll on normal viewports -->
    <div class="overflow-hidden">
      <div class="w-full">
        <table class="w-full divide-y divide-bosch-gray-200" style="table-layout: fixed; max-width: 100%;" role="table" aria-label="My shortened links">
          <thead class="bg-bosch-gray-50">
            <tr>
              @for (col of columns; track col) {
                <th (click)="setOrder(col)"
                  class="px-1.5 py-1.5 sm:px-3 sm:py-2 text-left text-xs font-bosch-medium text-bosch-gray-500 uppercase tracking-wider cursor-pointer hover:bg-bosch-gray-100 transition-colors whitespace-nowrap"
            [ngClass]="{
              'text-bosch-gray-900 font-bosch-strong': col.active,
              'text-bosch-gray-500': !col.active,
              'text-center': col.columnName === 'Redirects' || col.columnName === 'Owner',
              'w-auto min-w-[180px]': col.columnName === 'Short URL',
              'w-auto min-w-[185px] md:min-w-[210px] lg:min-w-[230px]': col.columnName === 'Long URL',
              'w-auto min-w-[90px]': col.columnName === 'Actions',
              'w-auto min-w-[50px]': col.columnName === 'Status',
              'w-auto min-w-[60px] text-center': col.columnName === 'Owner',
              'w-auto min-w-[100px]': col.columnName === 'Created',
              'w-auto min-w-[105px]': col.columnName === 'Modified',
              'w-auto min-w-[65px]': col.columnName === 'Redirects'
            }"
                  [attr.aria-sort]="col.active ? (col.reverse ? 'descending' : 'ascending') : 'none'"
                  [attr.aria-label]="'Sort by ' + col.columnName"
                  role="columnheader"
                  tabindex="0"
                  (keydown.enter)="setOrder(col)"
                  (keydown.space)="setOrder(col)">
                  <div class="flex items-center">
                    <span class="truncate flex-1 min-w-0">{{ col.columnName }}</span>
                    @if (col.active && col.reverse) {
                      <span class="ml-1 text-bosch-blue-500 flex-shrink-0" aria-hidden="true">▼</span>
                    }
                    @if (col.active && !col.reverse) {
                      <span class="ml-1 text-bosch-blue-500 flex-shrink-0" aria-hidden="true">▲</span>
                    }
                  </div>
                </th>
              }
              <th class="px-1.5 py-1.5 sm:px-3 sm:py-2 text-center text-xs font-bosch-medium text-bosch-gray-500 uppercase tracking-wider whitespace-nowrap w-auto min-w-[70px]" role="columnheader">
                <div class="flex items-center justify-center">
                  <input
                    type="checkbox"
                    (click)="toggleSelectAll()"
                    [checked]="isAllSelected()"
                    [indeterminate]="isIndeterminate()"
                    class="bci-checkbox bci-checkbox-compact"
                    aria-label="Select all items"
                    title="Select all items"
                    />
                  </div>
                </th>
              </tr></thead>
              @for (item of filteredRecords |
                paginate: {
                itemsPerPage: pageSize,
                currentPage: currentPage,
                } | orderBy: order:reverse; track item) {
                <tbody class="bg-white divide-y divide-bosch-gray-200" >
                  @if (showStatus(item)) {
                    <tr
              [ngClass]="{
                'border-b border-bosch-gray-200 hover:bg-bosch-gray-50 transition-colors': !item.isDeleted && !item.deleteError,
                'border-b border-bosch-gray-200 bg-bosch-gray-100 opacity-60 transition-colors': item.isDeleted && !item.isFadingOut && !item.deleteError,
                'border-b border-bosch-gray-200 bg-bosch-gray-100 opacity-0 transition-all duration-1000 transform scale-95': item.isFadingOut,
                'border-b border-pink-200 bg-pink-50 hover:bg-pink-100 transition-colors': item.deleteError
              }" 
                      role="row"
                      [attr.aria-label]="'Link row for ' + item.shortUrl + (item.isDeleted ? ' (marked for deletion)' : '') + (item.deleteError ? ' (delete failed)' : '')"
                      tabindex="0">
                      <!--| orderBy:'modifiedAt' : true -->
                      <td class="px-1.5 py-2 sm:px-3 sm:py-2 whitespace-nowrap" role="cell">
                        <div class="flex items-center  min-w-0">
                          <!-- [qrdata]="item.shortUrl" -->
                          <a [href]="item.qrCodeDownloadLink" class="qrcode flex-shrink-0" download="qrcode" [customTooltip]="'Download QR-Code'" tooltipClass="custom-tooltip"
                            [attr.aria-label]="'Download QR Code for ' + item.shortUrl"
                            tabindex="0">
                            <div class="qrcode-container"><div class="qrcode-scaled">
                              <!-- Important: for displaying link in QR-Code, use item.shortUrl or item.url for short or original link respectively. -->
                              <qrcode #qrcode (qrCodeURL)="onChangeURL($event,item)" [qrdata]="item.shortUrl" [allowEmptyString]="true"
                                [ariaLabel]="'QR-Code Image for ' + item.shortUrl" [cssClass]="'qrcode-scaled'" [colorDark]="'#ffffff'" [colorLight]="'#000000'"
                                [elementType]="'canvas'" [errorCorrectionLevel]="'M'" [imageSrc]="" [imageHeight]="" [imageWidth]=""
                              [margin]="2" [scale]="1" [title]="'download QR-Code'" [width]="640"></qrcode>
                            </div></div>
                          </a>
                          <button class="rounded-bosch-sm hover:bg-bosch-gray-100 transition-colors duration-200 flex-shrink-0"
                            (click)="copyContent(item.shortUrl);"
                            [attr.aria-label]="'Copy short link ' + item.shortUrl"
                            tabindex="0">
                            <img
                              src="../ui/assets/img/copy-svgrepo-com.svg"
                              alt="Copy Short Link"
                              [customTooltip]="'Copy Short Link'" tooltipClass="custom-tooltip"
                              class="w-5 h-5"
                              >
                            </button>
                            <a href="{{item.shortUrl}}" target="_blank" class="text-bosch-blue-600 hover:text-bosch-blue-800 truncate min-w-0 flex-1" >{{item.shortUrl}}
                              <!-- <input  type="text" [(ngModel)]="item.shortUrl" [disabled]="true" class="input-ShortUrl"/> -->
                            </a>
                          </div>
                        </td>
                        <td class="px-1.5 py-2 sm:px-3 sm:py-2">
                          @if (!item.isEditing) {
                            <div class="relative w-full">
                              <!-- Display mode - show as link like Short URL -->
                              <a [href]="item.url" target="_blank" class="text-bosch-blue-600 hover:text-bosch-blue-800 truncate min-w-0 block"
                                [attr.aria-label]="'Original URL: ' + item.url">
                                {{item.url}}
                              </a>
                            </div>
                          }
                          @if (item.isEditing) {
                            <div class="relative w-full">
                              <!-- Edit mode - show as BCI input -->
                              <input
                                type="text"
                                [(ngModel)]="item.url"
                                class="bci-input bci-input-compact w-full transition-colors duration-200"
                                [class.border-bosch-red-300]="item.isValidUrlEM"
                                [class.border-bosch-green-200]="item.isValidUrl"
                                [class.bg-bosch-red-100]="item.isValidUrlEM"
                                [class.bg-bosch-green-100]="item.isValidUrl"
                                (input)="checkIsValidURL(item)"
                                (blur)="checkIsValidURL(item)"
                                placeholder="Enter a valid URL (e.g., https://example.com)"
                                [attr.aria-label]="'Edit original URL for ' + item.shortUrl"
                                [attr.aria-describedby]="'url-validation-' + item._id"
                                required
                                />
                                <div
                                  [id]="'url-validation-' + item._id"
                                  [hidden]="!item.isValid_val"
                  [ngClass]="{
                    'text-black bg-bosch-green-50 border border-bosch-green-50': item.isValidUrl && !item.isValidUrlEM, 
                    'text-bosch-red-500 bg-bosch-red-100 border border-bosch-red-200': item.isValidUrlEM
                  }"
                                  class="px-2 py-1 rounded-md shadow-sm font-medium"
                                  role="alert"
                                  aria-live="polite"
                                  >
                                  <span class="inline-block mr-1" aria-hidden="true">{{ item.isValid_icon }}</span>
                                  <span>{{ item.isValid_val }}</span>
                                </div>
                              </div>
                            }
                          </td>
                          <td class="px-1.5 py-2 sm:px-3 sm:py-2 whitespace-nowrap" role="cell">
                            <div class="flex items-center justify-start">
              <button [ngClass]="{
                        'rounded-bosch-sm hover:bg-bosch-gray-100 transition-colors duration-200 flex-shrink-0': !item.isDeleted,
                        'rounded-bosch-sm cursor-not-allowed flex-shrink-0 opacity-50': item.isDeleted
                      }"
                                (click)="!item.isDeleted && toggleEdit(item)"
                                (keydown.escape)="onEscapePressed()"
                                [disabled]="item.isDeleted"
                                [attr.aria-label]="item.isDeleted ? 'Cannot edit deleted item' : (item.isEditing ? 'Currently editing URL' : 'Edit URL for ' + item.shortUrl)"
                                tabindex="0">
                                @if (!item.isEditing) {
                                  <img src="../ui/assets/img/edit.svg"  alt=""
                                    [customTooltip]="item.isDeleted ? 'Cannot edit deleted item' : 'Edit'"
                                    tooltipClass="custom-tooltip" class="w-5 h-5">
                                }
                              </button>
                              @if (item.isEditing && item.isValidUrl) {
                                <button class="rounded-bosch-sm hover:bg-bosch-gray-100 transition-colors duration-200 flex-shrink-0"
                                  (click)="updShortURL(item)"
                                  [attr.aria-label]="'Save changes to URL for ' + item.shortUrl"
                                  tabindex="0">
                                  <img src="../ui/assets/img/diskette-svgrepo-com.svg" alt="" customTooltip="Save"  tooltipClass="custom-tooltip" class="w-5 h-5">
                                </button>
                              }
                              @if (!item.isEditing) {
<button [ngClass]="{
                        'rounded-bosch-sm hover:bg-bosch-gray-100 transition-colors duration-200 flex-shrink-0': !item.isDeleted,
                        'rounded-bosch-sm cursor-not-allowed flex-shrink-0 opacity-50': item.isDeleted
                      }"
                                  (click)="!item.isDeleted && arcShortURL(item)"
                                  [disabled]="item.isDeleted"
                                  [attr.aria-label]="item.isDeleted ? 'Cannot archive/unarchive deleted item' : ((item.isArchived ? 'Publish' : 'Archive') + ' link ' + item.shortUrl)"
                                  tabindex="0">
                                  <img
                                    src="../ui/assets/img/{{item.isArchived ? 'unarchive-svgrepo-com' : 'archive'}}.svg"
                                    alt=""
                                    [customTooltip]="item.isDeleted ? 'Cannot archive/unarchive deleted item' : (item.isArchived ? 'Publish' : 'Archive')"
                                    tooltipClass="custom-tooltip"
                                    class="w-5 h-5"
                                    >
                                  </button>
                                }
                                <!-- Share button -->
                                @if (!item.isEditing) {
<button [ngClass]="{
                        'rounded-bosch-sm hover:bg-bosch-blue-50 transition-colors duration-200 flex-shrink-0': !item.isDeleted,
                        'rounded-bosch-sm cursor-not-allowed flex-shrink-0 opacity-50': item.isDeleted
                      }"
                                    (click)="!item.isDeleted && openShareDialog(item)"
                                    [disabled]="item.isDeleted"
                                    [attr.aria-label]="item.isDeleted ? 'Cannot share deleted item' : 'Share link ' + item.shortUrl"
                                    tabindex="0">
                                    <img
                                      [src]="isLinkShared(item) ? '../ui/assets/img/share-multiple.svg' : '../ui/assets/img/share.svg'"
                                      alt=""
                                      [customTooltip]="item.isDeleted ? 'Cannot share deleted item' : (isLinkShared(item) ? 'Shared with ' + item.selectedPeople.length + ' user(s)' : 'Share')"
                                      tooltipClass="custom-tooltip"
                                      class="w-5 h-5"
                                      >
                                    </button>
                                  }
                                  <!-- Delete/Undo button -->
                                  @if (!item.isEditing) {
<button [ngClass]="{
                        'rounded-bosch-sm hover:bg-pink-100 transition-colors duration-200 flex-shrink-0': !item.isDeleted,
                        'rounded-bosch-sm hover:bg-bosch-gray-100 transition-colors duration-200 flex-shrink-0': item.isDeleted
                      }"
                                      (click)="toggleDeleteShortURL(item)"
                                      [attr.aria-label]="(item.isDeleted ? 'Restore' : 'Delete') + ' link ' + item.shortUrl"
                                      tabindex="0">
                                      <img [src]="item.isDeleted ? '../ui/assets/img/undo-svgrepo-com.svg' : '../ui/assets/img/delete.svg'"
                                        alt=""
                                        [customTooltip]="item.deleteError ? 'Delete failed - try again' : (item.isDeleted ? 'Undo Delete' : 'Delete')"
                                        tooltipClass="custom-tooltip"
                                        [class]="item.deleteError ? 'w-5 h-5 text-pink-500' : 'w-5 h-5'">
                                      </button>
                                    }
                                    @if (item.isEditing) {
                                      <button class="rounded-bosch-sm hover:bg-bosch-gray-100 transition-colors duration-200 flex-shrink-0"
                                        (click)="item.url=item.backupurl; item.isEditing=false"
                                        [attr.aria-label]="'Cancel editing URL for ' + item.shortUrl"
                                        tabindex="0">
                                        <img src="../ui/assets/img/close-circle-svgrepo-com.svg" alt="" [customTooltip]="'Cancel'" tooltipClass="custom-tooltip" class="w-5 h-5">
                                      </button>
                                    }
                                  </div>
                                </td>
                                <td class="px-1.5 py-2 sm:px-3 sm:py-2 whitespace-nowrap text-sm w-auto max-w-0">
                                  <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium truncate max-w-full"
                  [ngClass]="{
                    'bg-pink-100 text-pink-800': item.isDeleted,
                    'bg-bosch-gray-100 text-bosch-gray-800': !item.isDeleted && item.isArchived,
                    'bg-bosch-green-100 text-bosch-green-800': !item.isDeleted && !item.isArchived
                  }">
                                    {{item.isDeleted ? 'Deleted' : (item.isArchived ? 'Archived' : 'Published') }}
                                  </span>
                                </td>
                                <td class="px-1.5 py-2 sm:px-3 sm:py-2 whitespace-nowrap text-center">
                                  <button
                                    (click)="openChangeOwnerModal([item])"
                                    [disabled]="item.isDeleted"
              [ngClass]="[
                'inline-flex items-center justify-center w-8 h-8 rounded-full text-xs font-bosch-strong text-white transition-all duration-200 hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed',
                item.isDeleted ? 'bg-bosch-gray-400' : getOwnerColor(item.creator),
                item.isDeleted ? '' : getOwnerHoverColor(item.creator)
              ]"
                                    [customTooltip]="item.creator || 'Unknown owner'"
                                    tooltipClass="custom-tooltip"
                                    [attr.aria-label]="'Change owner for ' + item.shortUrl">
                                    {{ getOwnerInitials(item.creator) }}
                                  </button>
                                </td>
                                <td class="px-1.5 py-2 sm:px-3 sm:py-2 whitespace-nowrap text-sm text-bosch-gray-900 w-auto max-w-0">
                                  <span class="block truncate">{{ item.dateCreated | date: 'yyyy-MM-dd' }}</span>
                                </td>
                                <td class="px-1.5 py-2 sm:px-3 sm:py-2 whitespace-nowrap text-sm text-bosch-gray-900 w-auto max-w-0">
                                  <span class="block truncate">{{ item.modifiedAt | date: 'yyyy-MM-dd' }}</span>
                                </td>
                                <td class="px-1.5 py-2 sm:px-3 sm:py-2 whitespace-nowrap text-center">
                                  <div class="redirects-container">
                                    <span class="text-sm font-medium text-bosch-gray-900" [customTooltip]="getRedirectsTooltip(item.redirectStats)" tooltipClass="custom-tooltip">{{ formatNumber(getTotalRedirects(item.redirectStats)) }}</span>
                                  </div>
                                </td>
                                <td class="px-1.5 py-2 sm:px-3 sm:py-2 whitespace-nowrap text-center">
                                  <div class="flex justify-center">
                                    <input type="checkbox"
                                      (click)="toggleSelect(item)"
                                      [(ngModel)]="item.selected"
                                      [disabled]="item.isDeleted && filterStatus !== 'Deleted'"
                                      class="bci-checkbox bci-checkbox-compact"
                                      [attr.aria-label]="'Select link ' + item.shortUrl + (item.isDeleted && filterStatus !== 'Deleted' ? ' (disabled - item is deleted)' : '')"/>
                                    </div>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          }
                        </table>
                      </div>
                    </div>
                  </div>

                  <!-- Conditional second header - appears when showing 20+ links on current page or when total > 20 and showing all -->
                  @if ((pageSize >= 20) || (pageSize === 999999 && filteredRecords.length >= 20)) {
                    <div class="border-t border-bosch-gray-200 bg-bosch-gray-50">
                      <table class="w-full" style="table-layout: fixed; max-width: 100%;" role="table" aria-label="Column headers for easier navigation">
                        <thead>
                          <tr>
                            @for (col of columns; track col) {
                              <th (click)="setOrder(col)"
                                class="px-1.5 py-1.5 sm:px-3 sm:py-2 text-left text-xs font-bosch-medium text-bosch-gray-500 uppercase tracking-wider cursor-pointer hover:bg-bosch-gray-100 transition-colors whitespace-nowrap"
          [ngClass]="{
            'text-bosch-gray-900 font-bosch-strong': col.active,
            'text-bosch-gray-500': !col.active,
            'text-center': col.columnName === 'Redirects' || col.columnName === 'Owner',
            'w-auto min-w-[180px]': col.columnName === 'Short URL',
            'w-auto min-w-[185px] md:min-w-[210px] lg:min-w-[230px]': col.columnName === 'Long URL',
            'w-auto min-w-[130px]': col.columnName === 'Actions',
            'w-auto min-w-[50px]': col.columnName === 'Status',
            'w-auto min-w-[60px] text-center': col.columnName === 'Owner',
            'w-auto min-w-[100px]': col.columnName === 'Created',
            'w-auto min-w-[105px]': col.columnName === 'Modified',
            'w-auto min-w-[65px]': col.columnName === 'Redirects'
          }"
                                [attr.aria-sort]="col.active ? (col.reverse ? 'descending' : 'ascending') : 'none'"
                                [attr.aria-label]="'Sort by ' + col.columnName"
                                role="columnheader"
                                tabindex="0"
                                (keydown.enter)="setOrder(col)"
                                (keydown.space)="setOrder(col)">
                                <div class="flex items-center">
                                  <span class="truncate flex-1 min-w-0">{{ col.columnName }}</span>
                                  @if (col.active && col.reverse) {
                                    <span class="ml-1 text-bosch-blue-500 flex-shrink-0" aria-hidden="true">▼</span>
                                  }
                                  @if (col.active && !col.reverse) {
                                    <span class="ml-1 text-bosch-blue-500 flex-shrink-0" aria-hidden="true">▲</span>
                                  }
                                </div>
                              </th>
                            }
                            <th class="px-1.5 py-1.5 sm:px-3 sm:py-2 text-center text-xs font-bosch-medium text-bosch-gray-500 uppercase tracking-wider whitespace-nowrap w-auto min-w-[70px]" role="columnheader">
                              <div class="flex items-center justify-center">
                                <input
                                  type="checkbox"
                                  (click)="toggleSelectAll()"
                                  [checked]="isAllSelected()"
                                  [indeterminate]="isIndeterminate()"
                                  class="bci-checkbox bci-checkbox-compact"
                                  aria-label="Select all items"
                                  title="Select all items"
                                  />
                                </div>
                              </th>
                            </tr>
                          </thead>
                        </table>
                      </div>
                    }

                    <!-- Bulk Actions -->
                    @if (selectedItemsCount > 0 || selectedItemsCountDeleted > 0 || (filterStatus === 'Deleted' && filteredRecords.length > 0)) {
                      <div class="flex flex-col sm:flex-row justify-between items-center mt-6">
                        <div class="flex gap-bosch-sm">
                          @if (filterStatus === 'All' || filterStatus === 'Archived') {
                            <button
                              (click)="handleCheckboxChange(true)"
                              [disabled]="!bulkBlueArchived"
                              class="inline-flex items-center gap-bosch-sm bg-bosch-green-500 hover:bg-bosch-green-600 disabled:bg-bosch-gray-300 disabled:cursor-not-allowed text-white font-bosch-medium py-bosch-sm px-bosch-lg rounded-bosch-md border-2 border-bosch-green-700 hover:border-bosch-green-800 disabled:border-bosch-gray-400 transition-all duration-200 text-center justify-center">
                              <img src="../ui/assets/img/publish-check.svg" alt="Publish" class="w-4 h-4 brightness-0 invert" />
                              Publish
                            </button>
                          }
                          @if (filterStatus === 'All' || filterStatus === 'Published') {
                            <button
                              (click)="handleCheckboxChange(false)"
                              [disabled]="!bulkBluePublished"
                              class="inline-flex items-center gap-bosch-sm bg-bosch-gray-500 hover:bg-bosch-gray-600 disabled:bg-bosch-gray-300 disabled:cursor-not-allowed text-white font-bosch-medium py-bosch-sm px-bosch-lg rounded-bosch-md border-2 border-bosch-gray-700 hover:border-bosch-gray-800 disabled:border-bosch-gray-400 transition-all duration-200 text-center justify-center">
                              <img src="../ui/assets/img/archive.svg" alt="Archive" class="w-4 h-4 brightness-0 invert" />
                              Archive
                            </button>
                          }
                          @if (filterStatus !== 'Deleted') {
                            <button
                              (click)="openBulkShareDialog()"
                              [disabled]="!bulkBlue"
                              class="inline-flex items-center gap-bosch-sm bg-bosch-blue-500 hover:bg-bosch-blue-600 disabled:bg-bosch-gray-300 disabled:cursor-not-allowed text-white font-bosch-medium py-bosch-sm px-bosch-lg rounded-bosch-md border-2 border-bosch-blue-700 hover:border-bosch-blue-800 disabled:border-bosch-gray-400 transition-all duration-200 text-center justify-center">
                              <img src="../ui/assets/img/share.svg" alt="Share Links" class="w-4 h-4 brightness-0 invert" />
                              Share Ownership
                            </button>
                          }
                          <!-- TEMPORARILY DISABLED: Bulk Edit Ownership button (will be enabled in future release) -->
                          <!--
                          <button *ngIf="filterStatus !== 'Deleted'"
                            (click)="openBulkChangeOwnerModal()"
                            [disabled]="!bulkBlue"
                            class="inline-flex items-center gap-bosch-sm bg-bosch-blue-500 hover:bg-bosch-blue-600 disabled:bg-bosch-gray-300 disabled:cursor-not-allowed text-white font-bosch-medium py-bosch-sm px-bosch-lg rounded-bosch-md border-2 border-bosch-blue-700 hover:border-bosch-blue-800 disabled:border-bosch-gray-400 transition-all duration-200 text-center justify-center">
                            <img src="../ui/assets/img/user-single.svg" alt="Edit Ownership" class="w-4 h-4 brightness-0 invert" />
                            Edit Ownership
                          </button>
                          -->
                          @if (filterStatus === 'Deleted') {
                            <button
                              (click)="permanentlyDeleteSelected()"
                              [disabled]="!bulkBlueDeleted"
                              class="inline-flex items-center gap-bosch-sm bg-bosch-gray-500 hover:bg-bosch-gray-600 disabled:bg-bosch-gray-300 disabled:cursor-not-allowed text-white font-bosch-medium py-bosch-sm px-bosch-lg rounded-bosch-md border-2 border-bosch-gray-700 hover:border-bosch-gray-800 disabled:border-bosch-gray-400 transition-all duration-200 text-center justify-center">
                              <img src="../ui/assets/img/delete.svg" alt="Delete" class="w-4 h-4 brightness-0 invert" />
                              Delete
                            </button>
                          }
                          @if (filterStatus === 'Deleted' && filteredRecords.length > 0) {
                            <button
                              (click)="emptyRecycleBin()"
                              class="inline-flex items-center gap-bosch-sm bg-bosch-blue-500 hover:bg-bosch-blue-600 text-white font-bosch-medium py-bosch-sm px-bosch-lg rounded-bosch-md border-2 border-bosch-blue-700 hover:border-bosch-blue-800 transition-all duration-200 text-center justify-center">
                              <img src="../ui/assets/img/delete.svg" alt="Empty Recycle Bin" class="w-4 h-4 brightness-0 invert" />
                              Empty Recycle Bin
                            </button>
                          }
                        </div>
                      </div>
                    }

                    <!-- Pagination -->
                    <div class="flex flex-col sm:flex-row justify-between items-center  mt-6">
                      <div class="flex items-center ">
                        <span class="text-sm text-gray-600">Show on page:</span>
                        <button (click)="getPageSize(10)" class="px-3 py-1 text-sm text-bosch-blue-500 hover:bg-bosch-blue-50 rounded-bosch-sm transition-colors duration-200 text-center">10</button>
                        <button (click)="getPageSize(20)" class="px-3 py-1 text-sm text-bosch-blue-500 hover:bg-bosch-blue-50 rounded-bosch-sm transition-colors duration-200 text-center">20</button>
                        <button (click)="getPageSize(30)" class="px-3 py-1 text-sm text-bosch-blue-500 hover:bg-bosch-blue-50 rounded-bosch-sm transition-colors duration-200 text-center">30</button>
                        <button (click)="getPageSize(0)" class="px-3 py-1 text-sm text-bosch-blue-500 hover:bg-bosch-blue-50 rounded-bosch-sm transition-colors duration-200 text-center">All</button>
                      </div>
                      <div>
                        <pagination-controls (pageChange)="pageChange($event)"></pagination-controls>
                      </div>
                    </div>
                  </div>

                  <!-- Share Dialog Component -->
                  <app-share-dialog #shareDialog (shareApplied)="handleShareApplied($event)"></app-share-dialog>

                  <!-- Change Owner Modal -->
                  @if (showChangeOwnerModal) {
                    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" (click)="closeChangeOwnerModal()">
                      <div class="bg-white rounded-bosch-lg shadow-xl max-w-md w-full mx-4" (click)="$event.stopPropagation()">
                        <!-- Modal Header -->
                        <div class="flex items-center justify-between p-bosch-lg border-b border-bosch-gray-200">
                          <h3 class="text-lg font-bosch-strong text-bosch-gray-900">Ownership</h3>
                          <button
                            (click)="closeChangeOwnerModal()"
                            class="p-1 rounded-bosch-sm hover:bg-bosch-gray-100 transition-colors"
                            [attr.aria-label]="'Close ownership dialog'">
                            <img src="../ui/assets/img/close-circle-svgrepo-com.svg" alt="" class="w-6 h-6">
                          </button>
                        </div>
                        <!-- Modal Body -->
                        <div class="p-bosch-lg space-y-bosch-md">
                          <!-- Link Information (supports multiple links) -->
                          <div class="bg-bosch-gray-50 border border-bosch-gray-200 rounded-bosch-md p-bosch-sm">
                            <div class="text-xs font-bosch-medium text-bosch-gray-600 mb-1">
                              {{ selectedItemsForOwnerChange.length === 1 ? 'Short URL:' : 'Links (' + selectedItemsForOwnerChange.length + '):' }}
                            </div>
                            @if (selectedItemsForOwnerChange.length === 1) {
                              <div>
                                <a [href]="selectedItemsForOwnerChange[0]?.shortUrl" target="_blank"
                                  class="text-sm text-bosch-blue-600 hover:text-bosch-blue-800 font-bosch-medium break-all">
                                  {{ selectedItemsForOwnerChange[0]?.shortUrl }}
                                </a>
                              </div>
                            }
                            @if (selectedItemsForOwnerChange.length > 1) {
                              <div class="text-sm text-bosch-gray-900">
                                {{ getLinksDisplayText() }}
                              </div>
                            }
                          </div>
                          <!-- Current Owner (single) or Owners (multiple) -->
                          @if (selectedItemsForOwnerChange.length === 1) {
                            <div>
                              <label class="block text-sm font-bosch-medium text-bosch-gray-700 mb-bosch-sm">
                                Current Owner
                              </label>
                              <div class="flex items-center gap-bosch-sm p-bosch-sm bg-bosch-gray-50 rounded-bosch-md">
                                <div [ngClass]="['flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bosch-strong', getOwnerColor(selectedItemsForOwnerChange[0]?.creator)]">
                                  {{ getOwnerInitials(selectedItemsForOwnerChange[0]?.creator) }}
                                </div>
                                <span class="text-sm text-bosch-gray-900">{{ selectedItemsForOwnerChange[0]?.creator || 'Unknown' }}</span>
                              </div>
                            </div>
                          }
                          @if (selectedItemsForOwnerChange.length > 1) {
                            <div>
                              <label class="block text-sm font-bosch-medium text-bosch-gray-700 mb-bosch-sm">
                                Current Owners ({{ selectedItemsForOwnerChange.length }} links)
                              </label>
                              <div class="text-sm text-bosch-gray-700 p-bosch-sm bg-bosch-gray-50 rounded-bosch-md">
                                Multiple owners - ownership will be transferred for all selected links
                              </div>
                            </div>
                          }
                          <!-- Step 2: New Owner Input (shown after "Transfer Ownership" is clicked) -->
                          @if (showTransferOwnershipInput) {
                            <div>
                              <label for="newOwnerEmail" class="block text-sm font-bosch-medium text-bosch-gray-700 mb-bosch-sm">
                                New Owner Email <span class="text-bosch-red-500">*</span>
                              </label>
                              <div class="relative">
                                <input
                                  id="newOwnerEmail"
                                  type="text"
                                  [(ngModel)]="newOwnerEmail"
                                  (input)="onOwnerEmailInput(newOwnerEmail)"
                                  (keydown.enter)="changeOwner()"
                                  (blur)="closeOwnerDropdown()"
                                  placeholder="Enter email or name to search"
                                  class="w-full px-bosch-md py-bosch-sm border rounded-bosch-md text-sm focus:outline-none focus:ring-2 transition-colors pr-10"
            [ngClass]="{
              'border-bosch-gray-300 focus:ring-bosch-blue-500 focus:border-bosch-blue-500': !ownerEmailValidationResult,
              'border-green-500 focus:ring-green-500 focus:border-green-500 bg-green-50': ownerEmailValidationResult?.exists === true,
              'border-red-500 focus:ring-red-500 focus:border-red-500 bg-red-50': ownerEmailValidationResult && (!ownerEmailValidationResult.isValid || !ownerEmailValidationResult.exists)
            }"
                                  [attr.aria-label]="'New owner email address'" />
                                  <!-- Validation indicator inside input -->
                                  <div class="absolute right-3 top-1/2 transform -translate-y-1/2">
                                    <!-- Loading spinner (for both email validation and user search) -->
                                    @if ((isValidatingOwnerEmail || isSearchingOwner) && newOwnerEmail.trim()) {
                                      <svg class="animate-spin h-5 w-5 text-bosch-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                      </svg>
                                    }
                                    <!-- Green check mark -->
                                    @if (!isValidatingOwnerEmail && !isSearchingOwner && ownerEmailValidationResult?.exists === true) {
                                      <svg class="h-5 w-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7"></path>
                                      </svg>
                                    }
                                    <!-- Red X mark -->
                                    @if (!isValidatingOwnerEmail && !isSearchingOwner && ownerEmailValidationResult && (!ownerEmailValidationResult.isValid || !ownerEmailValidationResult.exists)) {
                                      <svg class="h-5 w-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                      </svg>
                                    }
                                  </div>
                                  <!-- User search dropdown -->
                                  @if (showOwnerDropdown && ownerSearchResults.length > 0) {
                                    <div
                                      class="absolute z-50 w-full mt-1 bg-white border border-bosch-gray-300 rounded-bosch-md shadow-lg max-h-60 overflow-y-auto">
                                      @for (user of ownerSearchResults; track user) {
                                        <div
                                          (mousedown)="selectOwner(user)"
                                          class="px-bosch-md py-bosch-sm hover:bg-bosch-blue-50 cursor-pointer transition-colors">
                                          <div class="text-sm font-bosch-medium text-bosch-gray-900">{{ user.displayName }}</div>
                                          <div class="text-xs text-bosch-gray-600">{{ user.userPrincipalName || user.email }}</div>
                                        </div>
                                      }
                                    </div>
                                  }
                                </div>
                                <!-- Validation message -->
                                @if (ownerEmailValidationResult && newOwnerEmail.trim()) {
                                  <div class="mt-bosch-xs text-xs">
                                    @if (ownerEmailValidationResult.exists) {
                                      <p class="text-green-700 flex items-center gap-1">
                                        <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                                          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
                                        </svg>
                                        <span>User found: <strong>{{ ownerEmailValidationResult.displayName }}</strong></span>
                                      </p>
                                    }
                                    @if (!ownerEmailValidationResult.isValid) {
                                      <p class="text-red-700 flex items-center gap-1">
                                        <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                                          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                                        </svg>
                                        <span>{{ ownerEmailValidationResult.errorMessage || 'Invalid email format' }}</span>
                                      </p>
                                    }
                                    @if (ownerEmailValidationResult.isValid && !ownerEmailValidationResult.exists) {
                                      <p class="text-red-700 flex items-center gap-1">
                                        <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                                          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                                        </svg>
                                        <span>{{ ownerEmailValidationResult.errorMessage || 'User not found in organization' }}</span>
                                      </p>
                                    }
                                  </div>
                                }
                                <div class="bg-bosch-yellow-50 border-l-4 border-bosch-yellow-400 p-bosch-sm mt-bosch-sm">
                                  <div class="flex items-start gap-bosch-xs">
                                    <span class="text-bosch-yellow-700 text-lg" aria-hidden="true">⚠</span>
                                    <p class="text-xs text-bosch-yellow-700">
                                      Changing the owner will transfer full control of this link to the new owner. Additionally, Link will be automatically shared to you, and you become a collaborator with edit permissions. Make sure to confirm with the new owner before proceeding.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                          <!-- Modal Footer -->
                          <div class="flex justify-end gap-bosch-sm p-bosch-lg border-t border-bosch-gray-200">
                            <button
                              (click)="closeChangeOwnerModal()"
                              class="px-bosch-lg py-bosch-sm border border-bosch-gray-300 text-bosch-gray-700 font-bosch-medium rounded-bosch-md hover:bg-bosch-gray-50 transition-colors">
                              Close
                            </button>
                            <!-- TEMPORARILY DISABLED: Transfer ownership functionality (will be enabled in future release) -->
                            <!-- Step 1: Transfer Ownership button (before input is shown) -->
                            <!-- <button
                            *ngIf="!showTransferOwnershipInput"
                            (click)="showTransferOwnership()"
                            class="inline-flex items-center gap-bosch-sm px-bosch-lg py-bosch-sm bg-bosch-blue-500 hover:bg-bosch-blue-600 text-white font-bosch-medium rounded-bosch-md border-2 border-bosch-blue-700 hover:border-bosch-blue-800 transition-all duration-200">
                            Transfer Ownership
                          </button> -->
                          <!-- Step 2: Apply button (after input is shown) -->
                          <!-- <button
                          *ngIf="showTransferOwnershipInput"
                          (click)="changeOwner()"
                          [disabled]="!canTransferOwnership()"
                          class="inline-flex items-center gap-bosch-sm px-bosch-lg py-bosch-sm bg-bosch-blue-500 hover:bg-bosch-blue-600 disabled:bg-bosch-gray-300 disabled:cursor-not-allowed text-white font-bosch-medium rounded-bosch-md border-2 border-bosch-blue-700 hover:border-bosch-blue-800 disabled:border-bosch-gray-400 transition-all duration-200">
                          Apply
                        </button> -->
                      </div>
                    </div>
                  </div>
                }

                <!-- Copyright Notice -->
                <div class="w-full text-center py-bosch-lg mt-bosch-md text-sm">
                  <span class="text-bosch-gray-600 font-bosch"
                    >© Robert Bosch GmbH {{ compiledTimestamp | date : "yyyy" }}, all rights reserved</span
                    >
                  </div>




